<template>
  <div>
    <b-card class="mb-2" bg-variant="dark" border-variant="danger">
      <b-card-header header-bg-variant="secondary"><h5>mumble.apoplectic.net</h5></b-card-header>
      <div id="loadingDiv" class="text-center" style="padding-top: 5px" v-if="!mumbleStatusLoaded">
        <b-spinner label="Loading..." variant="danger"/>
      </div>
      <div id="overlay" class="overlay">
        Under Construction; mumble server will be available soon.
      </div>
      <div id="mumbleContentDiv" v-if="mumbleStatusLoaded">
        <b-row>
          <b-col>
            <b-card-text>The server is currently: {{ mumbleStatus }}</b-card-text>
          </b-col>
          <b-col cols="2">
            <div id="mumbleRefreshDiv" style="float: right;">
              <button class="refreshButton"
                      disabled
                      title="Refresh mumble status"
                      @click="getMumbleStatus(dashboardUser.signInUserSession.idToken.jwtToken)">
                <img id="refreshMumble" src="../assets/refresh.png" style="width:20px;height:20px;" alt="refresh icon"/>
              </button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-3">
            <b-button id="startMumble" @click="confirmMumbleStart" variant="outline-danger" disabled
                      v-if="mumbleStatus==='stopped'">
              Start Server
            </b-button>
            <div v-if="mumbleStatus==='running'">
              For connection instructions click
              <b-button id="viewMumble" @click="viewMumbleInfo" variant="outline-danger">Here</b-button>
            </div>
            <div v-if="mumbleStatus==='error'">
              <b-card-text>
                Unable to retrieve the mumble server information. If this error persists, please contact the
                administrators.
              </b-card-text>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="confirmInfoModal"
             title="Confirm mumble.apoplectic.net Startup"
             v-model="mumbleRequestModalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             ok-variant="outline-danger"
             cancel-variant="outline-danger"
             footer-bg-variant="dark"
             @ok="postMumbleStart()">
      <b-container id="confirmDiv" class="default-color">
        <p>Are you sure you wish to start the mumble server? </p>
      </b-container>
    </b-modal>

    <b-modal id="startupSuccessModal"
             title="Mumble server starting up"
             v-model="mumbleStartupModalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             ok-variant="outline-danger"
             footer-bg-variant="dark"
             ok-only
             @ok="getMumbleStatus(dashboardUser.signInUserSession.idToken.jwtToken)">
      <b-container id="successDiv" class="default-color">
        <p>Request to start mumble.apoplectic.net successfully sent. The service should be available shortly.</p>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import axios from 'axios'

export default {
  name: 'MumbleCard',
  data () {
    return {
      mumbleStatus: '',
      mumbleStatusLoaded: false,
      mumbleRequestModalShow: false,
      mumbleStartupModalShow: false,
      dashboardUser: null
    }
  },
  mounted () {
    Auth.currentAuthenticatedUser()
      .then(user => {
        this.dashboardUser = user
        // this.getMumbleStatus(user.signInUserSession.idToken.jwtToken)
        this.mumbleStatusLoaded = true
        this.mumbleStatus = 'error'
      })
  },
  methods: {
    async getMumbleStatus (idToken) {
      this.mumbleStatusLoaded = false
      let statusGetRequest = {
        method: 'GET',
        url: 'https://j7w7z3aeub.execute-api.us-east-2.amazonaws.com/test/apopmumblestatus',
        crossDomain: true,
        headers: {
          'content-type': 'application/json',
          'x-apop-token': idToken
        }
      }

      axios(statusGetRequest).then(response => {
        this.mumbleStatus = response.data.InstanceStatuses[0].InstanceState.Name
        this.mumbleStatusLoaded = true
      }).catch(err => {
        console.log(err.response)
        this.mumbleStatusLoaded = true
        this.mumbleStatus = 'error'
      })
    },
    confirmMumbleStart () {
      this.mumbleRequestModalShow = true
    },
    async postMumbleStart () {
      let idToken = this.dashboardUser.signInUserSession.idToken.jwtToken
      let startPostRequest = {
        method: 'POST',
        url: 'https://j7w7z3aeub.execute-api.us-east-2.amazonaws.com/test/apopmumblestart',
        crossDomain: true,
        headers: {
          'content-type': 'application/json',
          'x-apop-token': idToken
        }
      }

      axios(startPostRequest).then(response => {
        this.mumbleStatusLoaded = false
        this.mumbleStartupModalShow = true
      }).catch(err => {
        console.log(err.response)
        this.mumbleStatusLoaded = true
        this.mumbleStatus = 'error'
      })
    },
    viewMumbleInfo () {
      alert('viewing info')
    }
  }
}

</script>
